const modulePuzzle = require('@icons/streamline-icons/Outline version/04-Programing-Apps-Websites/02-Plugins-Modules/module-puzzle.svg');
const ticket1 = require('@icons/streamline-icons/Outline version/44-Entertainment-Event-Hobbies/11-Ticketing/ticket-1.svg');
const receiptRegisterPrint = require('@icons/streamline-icons/Outline version/09-Shopping-Ecommerce/04-Receipts/receipt-register-print.svg');
const performanceIncrease = require('@icons/streamline-icons/Outline version/06-Business-Products/11-Performances/performance-increase.svg');
const advertisingMegaphone = require('@icons/streamline-icons/Outline version/06-Business-Products/06-Advertising/advertising-megaphone.svg');
const billboard = require('@icons/streamline-icons/Outline version/06-Business-Products/06-Advertising/billboard.svg');
const bookFlipPage = require('@icons/streamline-icons/Outline version/11-Content/02-Books/book-flip-page.svg');
const linkBroken2 = require('@icons/streamline-icons/Outline version/01-Interface Essential/27-Link-Unlink/link-broken-2.svg');

export default {
  fallbackIcon: modulePuzzle,
  ticket1,
  receiptRegisterPrint,
  performanceIncrease,
  advertisingMegaphone,
  billboard,
  bookFlipPage,
  linkBroken2,
};
